// Load a script tag exactly once.
export async function loadScriptOnce(
  src: string
): Promise<void | HTMLScriptElement> {
  return new Promise((resolve, reject) => {
    const scripts = Array.from(document.getElementsByTagName('script'));
    if (scripts.some(script => script.src === src)) {
      resolve();
      return undefined;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    script.onload = () => resolve(script);
    script.onerror = error => reject(error);
    document.head.appendChild(script);
    return undefined;
  });
}
